import React from "react";
import { Row, Col } from "antd";
import { Card } from "antd";
import { BiMobile } from "react-icons/bi";
import { SiHomeassistantcommunitystore } from "react-icons/si";
import {
  MdVpnKey,
  MdModeEditOutline,
  MdEmail,
  MdOutlineBusiness,
} from "react-icons/md";
import { BsFilePerson } from "react-icons/bs";

const ProfileCard = ({
  headingText,
  businessInfo,
  userDetail,
  onClickBusinessDetails,
  onUpdateUserInfo,
  openChangePassword,
  ...props
}) => {
  return (
    <Row justify="start">
      <Col
        xs={24}
        sm={24}
        md={24}
        lg={24}
        xl={24}
        style={{ marginTop: "15px" }}
      >
        <Card>
          <Row justify="space-between">
            <Col xs={23} sm={12} md={12} lg={8} xl={8} align="start">
              <p className="st-cardheadingtext">{headingText}</p>
            </Col>
            <Col xs={1} sm={12} md={8} lg={8} xl={8} align="right">
              <MdModeEditOutline
                size="25"
                className="pointer-cursor"
                onClick={() => {
                  businessInfo
                    ? onClickBusinessDetails(userDetail)
                    : onUpdateUserInfo(userDetail);
                }}
              />
            </Col>
          </Row>
          <Row gutter={[0, 20]}>
            <Col xl={8} lg={8} xs={24} md={8} sm={8}>
              <Row justify="space-around">
                <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                  <BiMobile size="25" />
                </Col>
                <Col xs={16} sm={16} md={18} lg={18} xl={18}>
                  <Row>
                    <Col xs={4} sm={4} md={5} lg={5} xl={5}>
                      <span className="st-primary text-left">Phone</span>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      className="text-left"
                    >
                      <span>{userDetail?.phone}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col xl={8} lg={8} xs={24} md={8} sm={8}>
              <Row justify="space-around">
                <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                  <MdEmail size="25" />
                </Col>
                <Col xs={16} sm={16} md={18} lg={18} xl={18}>
                  <Row>
                    <Col xs={4} sm={4} md={5} lg={5} xl={4}>
                      <span className="st-primary text-left">Email</span>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      className="text-left"
                    >
                      <span>{userDetail?.email}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col xl={8} lg={8} xs={24} md={8} sm={8}>
              <Row justify="space-around">
                <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                  <SiHomeassistantcommunitystore size="25" />
                </Col>
                <Col xs={16} sm={16} md={18} lg={18} xl={18}>
                  <Row>
                    <Col xs={6} sm={4} md={5} lg={5} xl={4}>
                      <span className="st-primary text-left">Address</span>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      className="text-left"
                    >
                      <span>{userDetail?.address || "none"}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            {!businessInfo && (
              <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                <Row justify="space-around">
                  <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                    <MdVpnKey size="25" />
                  </Col>
                  <Col
                    xl={18}
                    xs={16}
                    sm={16}
                    md={17}
                    lg={18}
                    className="text-left"
                  >
                    <Row justify="space-between">
                      <Col xs={4} xl={6} md={6}>
                        <span className="st-primary text-left">Password</span>
                      </Col>
                      <Col xs={1} xl={2} md={5}>
                        <MdModeEditOutline
                          size="25"
                          className="pointer-cursor"
                          onClick={() => {
                            !businessInfo && openChangePassword();
                          }}
                        />
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                        className="text-left"
                      >
                        <span>********</span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            )}

            {businessInfo && (
              <>
                <Col xl={8} lg={8} xs={24} md={8} sm={8}>
                  <Row justify="space-around">
                    <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                      <MdOutlineBusiness size="25" />
                    </Col>
                    <Col xs={16} sm={17} md={17} lg={18} xl={18}>
                      <Row>
                        <Col
                          xs={24}
                          sm={24}
                          md={23}
                          lg={23}
                          xl={13}
                          style={{
                            textAlign: "left",
                          }}
                        >
                          <span className="st-primary text-left">
                            Business Name
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          className="text-left"
                        >
                          <span>{userDetail?.business_name}</span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col xl={8} lg={8} xs={24} md={9} sm={9}>
                  <Row justify="space-around">
                    <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                      <BsFilePerson size="25" />
                    </Col>
                    <Col xs={16} sm={18} md={18} lg={18} xl={18}>
                      <Row>
                        <Col
                          xs={24}
                          sm={24}
                          md={23}
                          lg={23}
                          xl={23}
                          style={{
                            textAlign: "left",
                          }}
                        >
                          <span className="st-primary text-left">
                            Employer Identification
                          </span>
                        </Col>
                        <Col
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          className="text-left"
                        >
                          <span>{userDetail?.employee_id_number}</span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </>
            )}
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default ProfileCard;
